import {inject, Injectable} from '@angular/core';
import {UserPreferencesService} from "../../../../services/user-preferences.service";
import {
  CreateNewProfileParams,
  SaveOrUpdateProfileParams
} from "../types/profile-column-modal.types";
import {ColumnProfile} from "../../../../types/user-preferences.types";

@Injectable({
  providedIn: 'root'
})
export class ProfileColumnModalService {
  private userPreferencesService: UserPreferencesService = inject(UserPreferencesService);

  public saveOrUpdateProfile(saveOrUpdateProfileParams: SaveOrUpdateProfileParams): Array<ColumnProfile> {
    const { currentProfileName, newProfileName } = saveOrUpdateProfileParams;
    const currentColumnProfiles = this.userPreferencesService.getUserPreferences()?.columnProfiles;
    const currentColumnProfile = currentColumnProfiles?.find(profile => profile.profileName === currentProfileName);

    if (currentProfileName && currentColumnProfile) {
      currentColumnProfile.profileName = newProfileName;
      this.userPreferencesService.saveUserPreferences({ columnProfiles: currentColumnProfiles });
      return currentColumnProfiles || [];
    }

    return this.createNewProfile({
      columnProfiles: currentColumnProfiles,
      newProfileName: newProfileName
    });
  }

  private createNewProfile({ columnProfiles, newProfileName }: CreateNewProfileParams): Array<ColumnProfile> {
    const newProfile: ColumnProfile = {
      profileName: newProfileName,
      isActive: true,
      hiddenColumnKeys: []
    };

    const currentActive = columnProfiles?.find(columnProfile => columnProfile.isActive);
    if (currentActive) {
      currentActive.isActive = false;
    }

    const newProfiles = columnProfiles ? [...columnProfiles, newProfile] : [newProfile];
    this.userPreferencesService.saveUserPreferences({ columnProfiles: newProfiles });
    return newProfiles;
  }
}
